import { ProductType } from "../../../../enums/shared/api/Api";
import agentApiService from "../../../../services/travel/new-policy/agentApiService";
import { FeedbackDetails } from "../../../../types/travel/Policy";

const createFeedback = (feedbackDetails: FeedbackDetails, quoteId: string, productType: ProductType) =>
  agentApiService.createFeedback(feedbackDetails, quoteId, productType);

export default createFeedback;
